export default "__VITE_ASSET__BRWz3$gl__"